// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.respond-section {
  width: 100%;
  height: 100vh;
  background-color: #812456;
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-end;
}
.respond-section::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 2px;
  background-color: #F5F5F5;
  bottom: -1px;
}
.respond-section .respond-section-container {
  width: calc(100% - 80px);
  height: calc(99vh - 88px);
  padding: 48px 0px 40px 80px;
  background-color: #F5F5F5;
  border-radius: 64px 64px 0px 0px;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
}
@media (min-width: 1620px) {
  .respond-section .respond-section-container {
    width: calc(100% - 100px);
    height: calc(99vh - 128px);
    padding: 56px 0px 72px 100px;
  }
}
@media (max-width: 1050px) {
  .respond-section .respond-section-container {
    width: calc(100% - 40px);
    height: calc(99svh - 48px);
    padding: 16px 0px 32px 40px;
  }
}
@media (max-width: 550px) {
  .respond-section .respond-section-container {
    width: calc(100% - 32px);
    height: calc(99svh - 64px);
    padding: 32px 16px 32px 16px;
    gap: 24px;
    border-radius: 24px 24px 0px 0px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
}
.respond-section .respond-section-container .respond-section-circle {
  width: 456px;
  position: absolute;
  z-index: 2;
  top: 0;
  right: -228px;
  animation: rotatingStar 18s linear infinite;
}
@media (min-width: 1620px) {
  .respond-section .respond-section-container .respond-section-circle {
    width: 600px;
    right: -300px;
  }
}
@media (max-width: 1150px) {
  .respond-section .respond-section-container .respond-section-circle {
    width: 300px;
    right: -150px;
  }
}
@media (max-width: 1150px) {
  .respond-section .respond-section-container .respond-section-circle {
    width: 326px;
    right: -163px;
    top: -24px;
  }
}
@media (max-width: 550px) {
  .respond-section .respond-section-container .respond-section-circle {
    width: 164px;
    right: -82px;
    top: 103px;
  }
}
.respond-section .respond-section-container .respond-section-title {
  width: 100%;
  padding: 40px 0 48px 0;
  border-bottom: 3px solid #EAEAEA;
  letter-spacing: -4.96px;
  text-transform: uppercase;
  color: #575756;
}
@media (min-width: 1620px) {
  .respond-section .respond-section-container .respond-section-title {
    padding: 40px 0 64px 0;
  }
}
@media (max-width: 1050px) {
  .respond-section .respond-section-container .respond-section-title {
    padding: 40px 0 40px 0;
  }
}
@media (max-width: 550px) {
  .respond-section .respond-section-container .respond-section-title {
    padding: 0px 0 24px 0;
  }
}
.respond-section .respond-section-container .respond-section-title h3 {
  font-family: FixelDisplay;
  font-size: 124px;
  font-style: normal;
  font-weight: 400;
  line-height: 90%;
}
@media (min-width: 1620px) {
  .respond-section .respond-section-container .respond-section-title h3 {
    letter-spacing: -6.4px;
    font-family: FixelDisplay;
    font-size: 160px;
    font-style: normal;
    font-weight: 400;
    line-height: 90%;
  }
}
@media (max-width: 1050px) {
  .respond-section .respond-section-container .respond-section-title h3 {
    letter-spacing: -1.92px;
    font-family: FixelDisplay;
    font-size: 64px;
    font-style: normal;
    font-weight: 400;
    line-height: 90%;
  }
}
@media (max-width: 550px) {
  .respond-section .respond-section-container .respond-section-title h3 {
    letter-spacing: -1.38px;
    font-family: FixelDisplay;
    font-size: 46px;
    font-style: normal;
    font-weight: 400;
    line-height: 90%;
  }
}
.respond-section .respond-section-container .respond-section-body {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: space-between;
}
@media (max-width: 800px) {
  .respond-section .respond-section-container .respond-section-body {
    position: relative;
    padding-top: 120px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-start;
  }
}
@media (max-width: 550px) {
  .respond-section .respond-section-container .respond-section-body {
    padding-top: 70px;
  }
}
.respond-section .respond-section-container .respond-section-body .respond-section-body-box {
  gap: 230px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
}
@media (min-width: 1620px) {
  .respond-section .respond-section-container .respond-section-body .respond-section-body-box {
    gap: 270px;
  }
}
@media (max-width: 1050px) {
  .respond-section .respond-section-container .respond-section-body .respond-section-body-box {
    gap: 270px;
  }
}
@media (max-width: 800px) {
  .respond-section .respond-section-container .respond-section-body .respond-section-body-box {
    gap: unset;
    position: absolute;
    top: 0;
    left: 0;
  }
}
.respond-section .respond-section-container .respond-section-body .respond-section-body-box .respond-section-body-label {
  width: 138px;
  height: 127px;
  position: relative;
}
@media (max-width: 1050px) {
  .respond-section .respond-section-container .respond-section-body .respond-section-body-box .respond-section-body-label {
    width: 131px;
    height: 134px;
  }
}
.respond-section .respond-section-container .respond-section-body .respond-section-body-box .respond-section-body-label .respond-label-quotes {
  width: 128px;
  height: 107px;
  position: absolute;
  bottom: 0;
  left: 0;
}
@media (max-width: 550px) {
  .respond-section .respond-section-container .respond-section-body .respond-section-body-box .respond-section-body-label .respond-label-quotes {
    width: 97px;
    height: 80px;
    bottom: unset;
    left: 12px;
    top: 7px;
  }
}
.respond-section .respond-section-container .respond-section-body .respond-section-body-box .respond-section-body-label .respond-label-circle {
  width: 38px;
  height: 38px;
  position: absolute;
  top: 0;
  left: 0;
}
@media (max-width: 550px) {
  .respond-section .respond-section-container .respond-section-body .respond-section-body-box .respond-section-body-label .respond-label-circle {
    width: 34px;
    height: 34px;
  }
}
.respond-section .respond-section-container .respond-section-body .respond-section-body-box .respond-section-body-label .respond-label-text-top {
  position: absolute;
  top: 0;
  right: 0;
  width: 90px;
  height: 20px;
  color: #313130;
  letter-spacing: 0.08px;
  text-transform: uppercase;
  font-family: FixelDisplay;
  font-size: 8px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%;
}
@media (max-width: 550px) {
  .respond-section .respond-section-container .respond-section-body .respond-section-body-box .respond-section-body-label .respond-label-text-top {
    width: 94px;
    height: 20px;
  }
}
.respond-section .respond-section-container .respond-section-body .respond-section-body-box .respond-section-body-label .respond-label-text-bottom {
  position: absolute;
  top: 24px;
  right: 0;
  width: 90px;
  height: 15px;
  color: #313130;
  letter-spacing: 0.14px;
  text-transform: uppercase;
  font-family: FixelDisplay;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 110%;
}
@media (max-width: 550px) {
  .respond-section .respond-section-container .respond-section-body .respond-section-body-box .respond-section-body-label .respond-label-text-bottom {
    width: 78px;
    height: 18px;
    top: 20px;
    right: 15px;
    letter-spacing: unset;
    font-family: FixelDisplay;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 130%;
  }
}
.respond-section .respond-section-container .respond-section-body .respond-section-body-box .respond-section-body-button {
  width: 127px;
  height: 100px;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-start;
}
@media (min-width: 1620px) {
  .respond-section .respond-section-container .respond-section-body .respond-section-body-box .respond-section-body-button {
    width: 177px;
    height: 140px;
  }
}
@media (max-width: 800px) {
  .respond-section .respond-section-container .respond-section-body .respond-section-body-box .respond-section-body-button {
    display: none;
  }
}
.respond-section .respond-section-container .respond-section-body .respond-section-body-box .respond-section-body-button .respond-section-body-button-inner {
  width: 100px;
  height: 100px;
  border-radius: 100px;
  background-color: #EAEAEA;
  color: #812456;
  position: relative;
  transition: color 0.3s ease-in-out;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
@media (min-width: 1620px) {
  .respond-section .respond-section-container .respond-section-body .respond-section-body-box .respond-section-body-button .respond-section-body-button-inner {
    width: 140px;
    height: 140px;
  }
}
.respond-section .respond-section-container .respond-section-body .respond-section-body-box .respond-section-body-button .respond-section-body-button-inner svg {
  position: relative;
  z-index: 2;
  rotate: 180deg;
}
.respond-section .respond-section-container .respond-section-body .respond-section-body-box .respond-section-body-button .respond-section-body-button-inner::before {
  content: "";
  width: 100px;
  height: 100px;
  border-radius: 100px;
  background-color: #812456;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0);
  transition: transform 0.3s ease-in-out;
  transform-origin: center;
}
@media (min-width: 1620px) {
  .respond-section .respond-section-container .respond-section-body .respond-section-body-box .respond-section-body-button .respond-section-body-button-inner::before {
    width: 140px;
    height: 140px;
  }
}
.respond-section .respond-section-container .respond-section-body .respond-section-body-box .respond-section-body-button .respond-section-body-button-inner:hover {
  color: #FFFFFF;
}
.respond-section .respond-section-container .respond-section-body .respond-section-body-box .respond-section-body-button .respond-section-body-button-inner:hover::before {
  transform: translate(-50%, -50%) scale(1);
}
.respond-section .respond-section-container .respond-section-body .respond-section-body-box .respond-section-body-button p {
  width: 108px;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  z-index: 2;
  color: #575756;
  text-transform: uppercase;
  font-family: FixelDisplay;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
}
@media (min-width: 1620px) {
  .respond-section .respond-section-container .respond-section-body .respond-section-body-box .respond-section-body-button p {
    font-family: FixelDisplay;
    font-size: 30px;
    font-style: normal;
    font-weight: 600;
    line-height: 100%;
  }
}

@keyframes rotatingCircle {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/RespondSection/RespondSection.scss","webpack://./src/styles/mixins.scss","webpack://./src/styles/variables.scss"],"names":[],"mappings":"AAGA;EACI,WAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;ECPA,aAAA;EACA,mBDOqB;ECNrB,uBDM0B;ECL1B,qBDKkC;AACtC;AACI;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,yBEZW;EFaX,YAAA;AACR;AAEI;EACI,wBAAA;EACA,yBAAA;EACA,2BAAA;EACA,yBEpBW;EFqBX,gCAAA;EACA,kBAAA;EACA,gBAAA;EC1BJ,aAAA;EACA,sBD0ByB;ECzBzB,8BDyBiC;ECxBjC,uBDwBgD;AAGpD;AADQ;EAVJ;IAWQ,yBAAA;IACA,0BAAA;IACA,4BAAA;EAIV;AACF;AAFQ;EAhBJ;IAiBQ,wBAAA;IACA,0BAAA;IACA,2BAAA;EAKV;AACF;AAHQ;EAtBJ;IAuBQ,wBAAA;IACA,0BAAA;IACA,4BAAA;IACA,SAAA;IACA,gCAAA;IC9CR,aAAA;IACA,sBD8C6B;IC7C7B,2BD6CqC;IC5CrC,uBD4CiD;EASnD;AACF;AAPQ;EACI,YAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,aAAA;EACA,2CAAA;AASZ;AAPY;EARJ;IASQ,YAAA;IACA,aAAA;EAUd;AACF;AARY;EAbJ;IAcQ,YAAA;IACA,aAAA;EAWd;AACF;AATY;EAlBJ;IAmBQ,YAAA;IACA,aAAA;IACA,UAAA;EAYd;AACF;AAVY;EAxBJ;IAyBQ,YAAA;IACA,YAAA;IACA,UAAA;EAad;AACF;AATQ;EACI,WAAA;EACA,sBAAA;EACA,gCAAA;EACA,uBAAA;EACA,yBAAA;EACA,cEjFA;AF4FZ;AATY;EARJ;IASO,sBAAA;EAYb;AACF;AAVY;EAZJ;IAaQ,sBAAA;EAad;AACF;AAXY;EAhBJ;IAiBQ,qBAAA;EAcd;AACF;AAZY;EC/FR,yBDgGiC;EC/FjC,gBD+F+C;EC9F/C,kBD8FsD;EC7FtD,gBD6F8D;EC5F9D,gBD4FmE;AAkBvE;AAhBgB;EAHJ;IAIQ,sBAAA;ICnGhB,yBDoGqC;ICnGrC,gBDmGmD;IClGnD,kBDkG0D;ICjG1D,gBDiGkE;IChGlE,gBDgGuE;EAuBzE;AACF;AArBgB;EARJ;IASQ,uBAAA;ICxGhB,yBDyGqC;ICxGrC,eDwGmD;ICvGnD,kBDuGyD;ICtGzD,gBDsGiE;ICrGjE,gBDqGsE;EA4BxE;AACF;AA1BgB;EAbJ;IAcQ,uBAAA;IC7GhB,yBD8GqC;IC7GrC,eD6GmD;IC5GnD,kBD4GyD;IC3GzD,gBD2GiE;IC1GjE,gBD0GsE;EAiCxE;AACF;AA7BQ;EACI,WAAA;EC3HR,aAAA;EACA,mBD2H6B;EC1H7B,8BD0HkC;ECzHlC,0BDyHiD;AAkCrD;AAhCY;EAJJ;IAKQ,kBAAA;IACA,kBAAA;IChIZ,aAAA;IACA,sBDgIiC;IC/HjC,yBD+HyC;IC9HzC,uBD8HmD;EAsCrD;AACF;AApCY;EAVJ;IAWQ,iBAAA;EAuCd;AACF;AArCY;EACI,UAAA;ECzIZ,aAAA;EACA,sBDyIiC;ECxIjC,8BDwIyC;ECvIzC,uBDuIwD;AA0C5D;AAxCgB;EAJJ;IAKQ,UAAA;EA2ClB;AACF;AAzCgB;EARJ;IASQ,UAAA;EA4ClB;AACF;AA1CgB;EAZJ;IAaQ,UAAA;IACA,kBAAA;IACA,MAAA;IACA,OAAA;EA6ClB;AACF;AA3CgB;EACI,YAAA;EACA,aAAA;EACA,kBAAA;AA6CpB;AA3CoB;EALJ;IAMQ,YAAA;IACA,aAAA;EA8CtB;AACF;AA5CoB;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;AA8CxB;AA5CwB;EAPJ;IAQQ,WAAA;IACA,YAAA;IACA,aAAA;IACA,UAAA;IACA,QAAA;EA+C1B;AACF;AA5CoB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AA8CxB;AA5CwB;EAPJ;IAQQ,WAAA;IACA,YAAA;EA+C1B;AACF;AA5CoB;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,cE/LjB;EFgMiB,sBAAA;EACA,yBAAA;ECnMpB,yBDoMyC;ECnMzC,cDmMuD;EClMvD,kBDkM4D;ECjM5D,gBDiMoE;EChMpE,iBDgMyE;AAkD7E;AAhDwB;EAXJ;IAYQ,WAAA;IACA,YAAA;EAmD1B;AACF;AAhDoB;EACI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,cEhNjB;EFiNiB,sBAAA;EACA,yBAAA;ECpNpB,yBDqNyC;ECpNzC,eDoNuD;ECnNvD,kBDmN6D;EClN7D,gBDkNqE;ECjNrE,iBDiN0E;AAsD9E;AApDwB;EAXJ;IAYQ,WAAA;IACA,YAAA;IACA,SAAA;IACA,WAAA;IACA,qBAAA;IC5NxB,yBD6N6C;IC5N7C,eD4N2D;IC3N3D,kBD2NiE;IC1NjE,gBD0NyE;ICzNzE,iBDyN8E;EA2DhF;AACF;AAvDgB;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EC5OhB,aAAA;EACA,mBD4OqC;EC3OrC,yBD2O0C;EC1O1C,uBD0OoD;AA4DxD;AA1DoB;EANJ;IAOQ,YAAA;IACA,aAAA;EA6DtB;AACF;AA3DoB;EAXJ;IAYQ,aAAA;EA8DtB;AACF;AA5DoB;EACI,YAAA;EACA,aAAA;EACA,oBAAA;EACA,yBEvPjB;EFwPiB,cEzPf;EF0Pe,kBAAA;EACA,kCAAA;EACA,eAAA;EChQpB,aAAA;EACA,mBDgQyC;EC/PzC,uBD+P8C;EC9P9C,mBD8PsD;AAiE1D;AA/DwB;EAXJ;IAYQ,YAAA;IACA,aAAA;EAkE1B;AACF;AAhEwB;EACI,kBAAA;EACA,UAAA;EACA,cAAA;AAkE5B;AA/DwB;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,oBAAA;EACA,yBE/QnB;EFgRmB,kBAAA;EACA,QAAA;EACA,SAAA;EACA,yCAAA;EACA,sCAAA;EACA,wBAAA;AAiE5B;AA/D4B;EAbJ;IAcQ,YAAA;IACA,aAAA;EAkE9B;AACF;AA/DwB;EACI,cEhSpB;AFiWR;AA7DoB;EACI,yCAAA;AA+DxB;AA5DoB;EACI,YAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;EACA,oBAAA;EACA,UAAA;EACA,cE3SZ;EF4SY,yBAAA;EC5SpB,yBD6SyC;EC5SzC,eD4SuD;EC3SvD,kBD2S6D;EC1S7D,gBD0SqE;ECzSrE,iBDyS0E;AAkE9E;AAhEwB;EAZJ;ICnShB,yBDgT6C;IC/S7C,eD+S2D;IC9S3D,kBD8SiE;IC7SjE,gBD6SyE;IC5SzE,iBD4S8E;EAuEhF;AACF;;AA7DA;EACI;IACE,uBAAA;EAgEJ;EA9DE;IACE,yBAAA;EAgEJ;AACF","sourcesContent":["@use '../../styles/mixins.scss';\n@import '../../styles/variables.scss';\n\n.respond-section {\n    width: 100%;\n    height: 100vh;\n    background-color: #812456;\n    position: relative;\n    z-index: 2;\n    @include mixins.flex(row, center, flex-end);\n\n    &::after {\n        content: '';\n        position: absolute;\n        width: 100%;\n        height: 2px;\n        background-color: $light-background;\n        bottom: -1px;\n    }\n\n    .respond-section-container {\n        width: calc(100% - 80px);\n        height: calc(99vh - 88px);\n        padding: 48px 0px 40px 80px;\n        background-color: $light-background;\n        border-radius: 64px 64px 0px 0px;\n        position: relative;\n        overflow: hidden;\n        @include mixins.flex(column, space-between, flex-start);\n\n        @media (min-width: 1620px) {\n            width: calc(100% - 100px);\n            height: calc(99vh - 128px);\n            padding: 56px 0px 72px 100px;\n        }\n\n        @media (max-width: 1050px) {\n            width: calc(100% - 40px);\n            height: calc(99svh - 48px);\n            padding: 16px 0px 32px 40px;\n        }\n\n        @media (max-width: 550px) {\n            width: calc(100% - 32px);\n            height: calc(99svh - 64px);\n            padding: 32px 16px 32px 16px;\n            gap: 24px;\n            border-radius: 24px 24px 0px 0px;\n            @include mixins.flex(column, flex-start, flex-start);\n        }\n\n        .respond-section-circle {\n            width: 456px;\n            position: absolute;\n            z-index: 2;\n            top: 0;\n            right: -228px;\n            animation: rotatingStar 18s linear infinite;\n        \n            @media (min-width: 1620px) {\n                width: 600px;\n                right: -300px;\n            }\n\n            @media (max-width: 1150px) {\n                width: 300px;\n                right: -150px;\n            }\n\n            @media (max-width: 1150px) {\n                width: 326px;\n                right: -163px;\n                top: -24px;\n            }\n\n            @media (max-width: 550px) {\n                width: 164px;\n                right: -82px;\n                top: 103px;\n            }\n\n        }\n\n        .respond-section-title {\n            width: 100%;\n            padding: 40px 0 48px 0;\n            border-bottom: 3px solid $grey;\n            letter-spacing: -4.96px;\n            text-transform: uppercase;\n            color: $grey-dark;\n\n            @media (min-width: 1620px) {\n               padding: 40px 0 64px 0;\n            }\n\n            @media (max-width: 1050px) {\n                padding: 40px 0 40px 0;\n            }\n\n            @media (max-width: 550px) {\n                padding: 0px 0 24px 0;\n            }\n\n            h3 {\n                @include mixins.font(FixelDisplay, 124px, normal, 400, 90%);\n\n                @media (min-width: 1620px) {\n                    letter-spacing: -6.4px;\n                    @include mixins.font(FixelDisplay, 160px, normal, 400, 90%);\n                }\n\n                @media (max-width: 1050px) {\n                    letter-spacing: -1.92px;\n                    @include mixins.font(FixelDisplay, 64px, normal, 400, 90%);\n                }\n\n                @media (max-width: 550px) {\n                    letter-spacing: -1.38px;\n                    @include mixins.font(FixelDisplay, 46px, normal, 400, 90%);\n                }\n            }\n        }\n\n        .respond-section-body {\n            width: 100%;\n            @include mixins.flex(row, space-between, space-between);\n\n            @media (max-width: 800px) {\n                position: relative;\n                padding-top: 120px;\n                @include mixins.flex(column, flex-end, flex-start);\n            }\n\n            @media (max-width: 550px) {\n                padding-top: 70px;\n            }\n\n            .respond-section-body-box {\n                gap: 230px;\n                @include mixins.flex(column, space-between, flex-start);\n\n                @media (min-width: 1620px) {\n                    gap: 270px;\n                }\n\n                @media (max-width: 1050px) {\n                    gap: 270px;\n                }\n\n                @media (max-width: 800px) {\n                    gap: unset;\n                    position: absolute;\n                    top: 0;\n                    left: 0;\n                }\n\n                .respond-section-body-label {\n                    width: 138px;\n                    height: 127px;\n                    position: relative;\n\n                    @media (max-width: 1050px) {\n                        width: 131px;\n                        height: 134px;\n                    }\n\n                    .respond-label-quotes {\n                        width: 128px;\n                        height: 107px;\n                        position: absolute;\n                        bottom: 0;\n                        left: 0;\n\n                        @media (max-width: 550px) {\n                            width: 97px;\n                            height: 80px;\n                            bottom: unset;\n                            left: 12px;\n                            top: 7px;\n                        }\n                    }\n\n                    .respond-label-circle {\n                        width: 38px;\n                        height: 38px;\n                        position: absolute;\n                        top: 0;\n                        left: 0;\n\n                        @media (max-width: 550px) {\n                            width: 34px;\n                            height: 34px;\n                        }\n                    }\n\n                    .respond-label-text-top {\n                        position: absolute;\n                        top: 0;\n                        right: 0;\n                        width: 90px;\n                        height: 20px;\n                        color: $dark;\n                        letter-spacing: 0.08px;\n                        text-transform: uppercase;\n                        @include mixins.font(FixelDisplay, 8px, normal, 500, 130%);\n\n                        @media (max-width: 550px) {\n                            width: 94px;\n                            height: 20px;\n                        }\n                    }\n\n                    .respond-label-text-bottom {\n                        position: absolute;\n                        top: 24px;\n                        right: 0;\n                        width: 90px;\n                        height: 15px;\n                        color: $dark;\n                        letter-spacing: 0.14px;\n                        text-transform: uppercase;\n                        @include mixins.font(FixelDisplay, 14px, normal, 500, 110%);\n\n                        @media (max-width: 550px) {\n                            width: 78px;\n                            height: 18px;\n                            top: 20px;\n                            right: 15px;\n                            letter-spacing: unset;\n                            @include mixins.font(FixelDisplay, 14px, normal, 500, 130%);\n                        }\n                    }\n                }\n\n                .respond-section-body-button {\n                    width: 127px;\n                    height: 100px;\n                    position: relative;\n                    @include mixins.flex(row, flex-end, flex-start);\n\n                    @media (min-width: 1620px) {\n                        width: 177px;\n                        height: 140px;\n                    }\n\n                    @media (max-width: 800px) {\n                        display: none;\n                    }\n\n                    .respond-section-body-button-inner {\n                        width: 100px;\n                        height: 100px;\n                        border-radius: 100px;\n                        background-color: $grey;\n                        color: $purple;\n                        position: relative;\n                        transition: color 0.3s ease-in-out;\n                        cursor: pointer;\n                        @include mixins.flex(row, center, center);\n\n                        @media (min-width: 1620px) {\n                            width: 140px;\n                            height: 140px;\n                        }\n    \n                        svg {\n                            position: relative;\n                            z-index: 2;\n                            rotate: 180deg;\n                        }\n    \n                        &::before {\n                            content: '';\n                            width: 100px;\n                            height: 100px;\n                            border-radius: 100px;\n                            background-color: $purple;\n                            position: absolute;\n                            top: 50%;\n                            left: 50%;\n                            transform: translate(-50%, -50%) scale(0);\n                            transition: transform 0.3s ease-in-out;\n                            transform-origin: center;\n\n                            @media (min-width: 1620px) {\n                                width: 140px;\n                                height: 140px;\n                            }\n                        }\n        \n                        &:hover {\n                            color: $white;\n                        }\n                    }\n    \n                    .respond-section-body-button-inner:hover::before {\n                        transform: translate(-50%, -50%) scale(1);\n                    }\n\n                    p {\n                        width: 108px;\n                        position: absolute;\n                        left: 0;\n                        top: 50%;\n                        transform: translateY(-50%);\n                        pointer-events: none;\n                        z-index: 2;\n                        color: $grey-dark;\n                        text-transform: uppercase;\n                        @include mixins.font(FixelDisplay, 24px, normal, 600, 100%);\n\n                        @media (min-width: 1620px) {\n                            @include mixins.font(FixelDisplay, 30px, normal, 600, 100%);\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n// Stars Rotating Animation\n\n@keyframes rotatingCircle {\n    from {\n      transform: rotate(0deg);\n    }\n    to {\n      transform: rotate(360deg);\n    }\n  }","@mixin flex($dir, $jc, $ai) {\n    display: flex;\n    flex-direction: $dir;\n    justify-content: $jc;\n    align-items: $ai;\n}\n\n@mixin font ($font, $size, $style, $weight, $height) {\n    font-family: $font;\n    font-size: $size;\n    font-style: $style;\n    font-weight: $weight;\n    line-height: $height;\n}","// Colors\n\n$main-color: #982D67;\n$white: #FFFFFF;\n$light-background: #F5F5F5;\n$purple: #812456;\n$grey: #EAEAEA;\n$grey-opacity:#E0E0E0;\n$grey-dark: #575756;\n$grey-text: #BCBCBC;\n$dark: #313130;\n$red: #AE2323;\n$opacity-text: rgba(255, 255, 255, 0.50);"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
